import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { getAsset } from '../../../../../../../../../util/assets';

const propTypes = {
  account: PropTypes.shape({
    id: PropTypes.string,
    logo_image: PropTypes.shape({
      id: PropTypes.string,
      url: PropTypes.string,
    }),
  }).isRequired,
};
const BusinessCardFront = ({ account, ...props }) => {
  const templateRef = useRef(null);
  const { logo_image: logo } = account ?? {};

  return (
    <div
      className="marketing-material-business-card marketing-material-business-card-front"
      {...props}
    >
      <div className="marketing-material-business-card-front-logo">
        {logo?.url && <img src={logo.url} alt="" />}
      </div>
      <img
        ref={templateRef}
        src={getAsset(
          '/marketing-material/MARKETING_BUSINESS_CARD_GENERAL_BACK.png',
        )}
        alt=""
      />
    </div>
  );
};

BusinessCardFront.propTypes = propTypes;

export default BusinessCardFront;
